
<template>
  <select>
    <option v-if="options.length==0" value="Ghana">Ghana</option>
    <option
      v-for="country in options"
      :value="country"
    >{{ country }}</option>
  </select>
</template>

<script>
export default {
  name: "jquery-selectmenu",
  props: ['value', 'options'],
  mounted: function() {
    this.buildSelectMenu(this.value)
  },
  watch: {
    value: function (value) {
      $(this.$el).val(value).selectmenu('refresh');
    },
  },
  methods: {
    buildSelectMenu: function(value){
      const emit = value => this.$emit('input', value);
      $(this.$el).selectmenu({
        change: function(event, data) {
          emit(data.item.value);
        }
      });
      $(this.$el).val(value).selectmenu('refresh');
    }
  },
  updated() {
    this.buildSelectMenu(this.value)
  },

};
</script>
